function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "polygon-logo",
  fill: "#FFFEFB",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M197.648,68.8237 C192.815,65.9756 186.533,65.9756 181.218,68.8237 L143.524,90.6592 L117.912,104.9 L80.219,126.735 C75.3865,129.583 69.1043,129.583 63.7886,126.735 L33.8273,109.646 C28.9948,106.798 25.6121,101.577 25.6121,95.8807 L25.6121,62.1781 C25.6121,56.4819 28.5116,51.2604 33.8273,48.4123 L63.3053,31.7984 C68.1378,28.9503 74.42,28.9503 79.7357,31.7984 L109.214,48.4123 C114.046,51.2604 117.429,56.4819 117.429,62.1781 L117.429,84.0136 L143.041,69.2984 L143.041,47.463 C143.041,41.7667 140.142,36.5452 134.826,33.6971 L80.219,2.36801 C75.3865,-0.480092 69.1043,-0.480092 63.7886,2.36801 L8.2152,33.6971 C2.89948,36.5452 0,41.7667 0,47.463 L0,110.596 C0,116.292 2.89948,121.514 8.2152,124.362 L63.7886,155.691 C68.621,158.539 74.9033,158.539 80.219,155.691 L117.912,134.33 L143.524,119.615 L181.218,98.2541 C186.05,95.406 192.332,95.406 197.648,98.2541 L227.126,114.868 C231.958,117.716 235.341,122.938 235.341,128.634 L235.341,162.336 C235.341,168.033 232.442,173.254 227.126,176.102 L197.648,193.191 C192.815,196.039 186.533,196.039 181.218,193.191 L151.74,176.577 C146.907,173.729 143.524,168.507 143.524,162.811 L143.524,140.976 L117.912,155.691 L117.912,177.526 C117.912,183.222 120.812,188.444 126.127,191.292 L181.701,222.621 C186.533,225.469 192.815,225.469 198.131,222.621 L253.705,191.292 C258.537,188.444 261.92,183.222 261.92,177.526 L261.92,114.393 C261.92,108.697 259.02,103.476 253.705,100.628 L197.648,68.8237 Z",
  id: "Path"
})));

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "262px",
    height: "225px",
    viewBox: "0 0 262 225",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.7dd8c525.svg";
export { ForwardRef as ReactComponent };